import { SHIPMENT_SOLUTION_TYPES } from "~/cores/shipment.core";
import { createReturnReasonConfigShoes } from "../mockCore";

export function getExchange({ productId }) {
    if (productId === "1") {
        return {
            exchangeAlternatives: [
                {
                    id: "1",
                    imageUrl: "/mocks/Shoes, black boots.jpeg",
                    inventoryMerchant: 1,
                    inventoryTurnr: 1,
                    inventoryTotal: 2,
                    properties: [
                        {
                            type: "Size",
                            value: "36",
                        },
                    ],
                },
                {
                    id: "2",
                    imageUrl: "/mocks/Shoes, black boots.jpeg",
                    inventoryMerchant: 1,
                    inventoryTurnr: 0,
                    inventoryTotal: 1,
                    properties: [
                        {
                            type: "Size",
                            value: "37",
                        },
                    ],
                },
                {
                    id: "3",
                    imageUrl: "/mocks/Shoes, black boots.jpeg",
                    inventoryMerchant: 1,
                    inventoryTurnr: 0,
                    inventoryTotal: 1,
                    properties: [
                        {
                            type: "Size",
                            value: "40",
                        },
                    ],
                },
            ],
        };
    }
    if (productId === "2") {
        return {
            exchangeAlternatives: [
                {
                    id: "1",
                    imageUrl: "/mocks/Shoes, beige ballerina.jpeg",
                    inventoryMerchant: 1,
                    inventoryTurnr: 1,
                    inventoryTotal: 2,
                    properties: [
                        {
                            type: "Color",
                            value: "Beige",
                        },
                        {
                            type: "Size",
                            value: "35",
                        },
                    ],
                },
                {
                    id: "2",
                    imageUrl: "/mocks/Shoes, beige ballerina.jpeg",
                    inventoryMerchant: 0,
                    inventoryTurnr: 1,
                    inventoryTotal: 1,
                    properties: [
                        {
                            type: "Color",
                            value: "Beige",
                        },
                        {
                            type: "Size",
                            value: "36",
                        },
                    ],
                },
                {
                    id: "3",
                    imageUrl: "/mocks/Shoes, beige ballerina.jpeg",
                    inventoryMerchant: 1,
                    inventoryTurnr: 0,
                    inventoryTotal: 0,
                    properties: [
                        {
                            type: "Color",
                            value: "Beige",
                        },
                        {
                            type: "Size",
                            value: "39",
                        },
                    ],
                },
                {
                    id: "6",
                    imageUrl: "/mocks/Shoes, white ballerina.jpeg",
                    inventoryMerchant: 1,
                    inventoryTurnr: 1,
                    inventoryTotal: 2,
                    properties: [
                        {
                            type: "Color",
                            value: "White",
                        },
                        {
                            type: "Size",
                            value: "37",
                        },
                    ],
                },
                {
                    id: "7",
                    imageUrl: "/mocks/Shoes, black ballerina.jpeg",
                    inventoryMerchant: 1,
                    inventoryTurnr: 0,
                    inventoryTotal: 1,
                    properties: [
                        {
                            type: "Color",
                            value: "Black",
                        },
                        {
                            type: "Size",
                            value: "38",
                        },
                    ],
                },
            ],
        };
    }
    if (productId === "3") {
        return {
            exchangeAlternatives: [
                {
                    id: "1",
                    imageUrl: "/mocks/Shoes, white sneakers.jpeg",
                    inventoryMerchant: 1,
                    inventoryTurnr: 1,
                    inventoryTotal: 2,
                    properties: [
                        {
                            type: "Color",
                            value: "White",
                        },
                        {
                            type: "Size",
                            value: "37",
                        },
                    ],
                },
                {
                    id: "2",
                    imageUrl: "/mocks/Shoes, white sneakers.jpeg",
                    inventoryMerchant: 1,
                    inventoryTurnr: 0,
                    inventoryTotal: 1,
                    properties: [
                        {
                            type: "Color",
                            value: "White",
                        },
                        {
                            type: "Size",
                            value: "39",
                        },
                    ],
                },
                {
                    id: "3",
                    imageUrl: "/mocks/Shoes, white sneakers.jpeg",
                    inventoryMerchant: 1,
                    inventoryTurnr: 0,
                    inventoryTotal: 1,
                    properties: [
                        {
                            type: "Color",
                            value: "White",
                        },
                        {
                            type: "Size",
                            value: "40",
                        },
                    ],
                },
                {
                    id: "4",
                    imageUrl: "/mocks/Shoes, black sneakers.jpeg",
                    inventoryMerchant: 2,
                    inventoryTurnr: 1,
                    inventoryTotal: 1,
                    properties: [
                        {
                            type: "Color",
                            value: "Black",
                        },
                        {
                            type: "Size",
                            value: "37",
                        },
                    ],
                },
                {
                    id: "5",
                    imageUrl: "/mocks/Shoes, black sneakers.jpeg",
                    inventoryMerchant: 1,
                    inventoryTurnr: 1,
                    inventoryTotal: 1,
                    properties: [
                        {
                            type: "Color",
                            value: "Black",
                        },
                        {
                            type: "Size",
                            value: "38",
                        },
                    ],
                },
                {
                    id: "6",
                    imageUrl: "/mocks/Shoes, black sneakers.jpeg",
                    inventoryMerchant: 1,
                    inventoryTurnr: 1,
                    inventoryTotal: 1,
                    properties: [
                        {
                            type: "Color",
                            value: "Black",
                        },
                        {
                            type: "Size",
                            value: "39",
                        },
                    ],
                },
            ],
        };
    }
}

export function getProducts() {
    return {
        sessionId: "170bfc7b-8910-43a7-8903-52c9894ed015",
        shipmentSolutions: [
            {
                carrier: "DOORIS",
                type: SHIPMENT_SOLUTION_TYPES.PICKUP.key,
                cost: 0,
            },
            {
                carrier: "BUDBEE",
                type: SHIPMENT_SOLUTION_TYPES.PICKUP.key,
                cost: 39,
            },
            {
                carrier: "POSTNORD",
                type: SHIPMENT_SOLUTION_TYPES.PRINT_LABEL.key,
                cost: 39,
            },
        ],
        pickupDateSelectionAllowed: true,
        paidShipping: 40,
        turnrShippingCost: 59,
        currencyCode: "SEK",
        refundOptions: [
            {
                type: "BASIC",
            },
            {
                type: "GIFT_CARD",
                bonusPercentage: 0.2,
            },
        ],
        products: [
            {
                productVariantId: 10,
                sessionItemId: 1,
                productName: "Cecilia ankle boots",
                imageSrc: "/mocks/Shoes, black boots.jpeg",
                imageAlt: "/mocks/Shoes, black boots.jpeg",
                quantity: 1,
                purchasePrice: 999,
                properties: [
                    {
                        type: "Size",
                        value: "38",
                    },
                    {
                        type: "Color",
                        value: "Black",
                    },
                ],
                returnReasonConfig: createReturnReasonConfigShoes(),
            },
            {
                productVariantId: 20,
                sessionItemId: 2,
                productName: "Agnes ballerina",
                imageSrc: "/mocks/Shoes, beige ballerina.jpeg",
                imageAlt: "/mocks/Shoes, beige ballerina.jpeg",
                quantity: 1,
                purchasePrice: 599,
                properties: [
                    {
                        type: "Color",
                        value: "Beige",
                    },
                    {
                        type: "Size",
                        value: "38",
                    },
                ],
                returnReasonConfig: createReturnReasonConfigShoes(),
            },
            {
                productVariantId: 30,
                sessionItemId: 3,
                productName: "Chunky sneakers",
                imageSrc: "/mocks/Shoes, white sneakers.jpeg",
                imageAlt: "/mocks/Shoes, white sneakers.jpeg",
                quantity: 1,
                purchasePrice: 799,
                properties: [
                    {
                        type: "Size",
                        value: "38",
                    },
                    {
                        type: "Color",
                        value: "White",
                    },
                ],
                returnReasonConfig: createReturnReasonConfigShoes(),
            },
        ],
    };
}
